import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Observable, shareReplay, map } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SvgCacheService {
  private cache = new Map<string, Observable<SafeHtml>>();
  private http = inject(HttpClient);
  private sanitizer = inject(DomSanitizer);

  getSvg(path: string): Observable<SafeHtml> {
    if (this.cache.has(path)) {
      return this.cache.get(path)!;
    }

    const svg$ = this.http.get(path, { responseType: "text" }).pipe(
      map((svgContent) => this.sanitizer.bypassSecurityTrustHtml(svgContent)),
      shareReplay(1),
    );

    this.cache.set(path, svg$);
    return svg$;
  }
}
